import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

if ( document.querySelectorAll('.swiper-temoignages').length ) {
    let swiper = new Swiper('.swiper-temoignages', {
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

if ( document.querySelectorAll('.swiper-equipe').length ) {
    let swiper = new Swiper('.swiper-equipe', {
        loop: true,
        modules: [Navigation],
        navigation: {
            nextEl: '#btn-equipe-next',
            prevEl: '#btn-equipe-prev',
        },
        breakpoints: {
            992: {
              slidesPerView: 4.2,
              spaceBetween: 12,
            },
        },
    });
}
